import React from "react"

import imgNum1 from "./../../../assets/images/packaging-delivery/1.png"
import imgNum2 from "./../../../assets/images/packaging-delivery/2.png"
import imgNum3 from "./../../../assets/images/packaging-delivery/3.png"
import imgNumberPoints from "./../../../assets/images/packaging-delivery/puntos.png"

import "./packaging-delivery-section-2.scss"

function PackagingDeliverySection2() {
  return (
    <div className="f-packaging-delivery-section-2">
      <div className="f-packaging-delivery-section-2__container">
        <h2 className="f-packaging-delivery-section-2__title">
          Así puedes{" "}
          <span className="f-packaging-delivery-section-2__title__span-fill">
            ayudarnos
          </span>
        </h2>
        <div className="f-packaging-delivery-section-2__steps">
          <div className="f-packaging-delivery-section-2__steps__step-1">
            <h3 className="f-packaging-delivery-section-2__steps__step-1__title">
              <img
                src={imgNum1}
                alt="Numero 1"
                className="f-packaging-delivery-section-2__steps__step-1__title__number"
              />

              <span className="f-packaging-delivery-section-2__steps__step-1__title__text">
                Reúne mínimo
                <br />
                <em>10 </em>
                <b>Empaques</b>
              </span>
            </h3>
            <p className="f-packaging-delivery-section-2__steps__step-1__paragraph">
              <span className="f-packaging-delivery-section-2__steps__step-1__paragraph__bold">
                De cualquier producto Nosotras que hayas comprado
              </span>{" "}
              (no aplican muestras gratis ni empaques individuales)
            </p>
          </div>
          <div className="f-packaging-delivery-section-2__steps__step-2">
            <h3 className="f-packaging-delivery-section-2__steps__step-2__title">
              <img
                src={imgNum2}
                alt="Numero 2"
                className="f-packaging-delivery-section-2__steps__step-2__title__number"
              />
              <span className="f-packaging-delivery-section-2__steps__step-2__title__text">
                Lleva todos los empaques en
                <br />
                <b>un mismo sobre con tus datos</b>
              </span>
            </h3>
            <p className="f-packaging-delivery-section-2__steps__step-2__paragraph">
              A un punto de Servientrega Autorizado{" "}
              <a
                href="#searcher"
                className="f-packaging-delivery-section-2__steps__step-2__paragraph__link"
              >
                conócelos aquí
              </a>
            </p>
            <ul className="f-packaging-delivery-section-2__steps__step-2__list">
              <li className="f-packaging-delivery-section-2__steps__step-2__list__item">
                Nombres y apellidos completos.
              </li>
              <li className="f-packaging-delivery-section-2__steps__step-2__list__item">
                E-mail con el cual{" "}
                <b>estás registrada en NosotrasOnline.com.co</b> Si no estás
                registrada, puedes hacerlo{" "}
                <a
                  className="f-packaging-delivery-section-2__steps__step-2__list__item__link"
                  href={"/registro/fecha-de-nacimiento"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  aquí
                </a>
              </li>
              <li className="f-packaging-delivery-section-2__steps__step-2__list__item">
                Teléfono o celular de contacto
              </li>
              <li className="f-packaging-delivery-section-2__steps__step-2__list__item">
                Marca el sobre como: <b>Programa de puntos Nosotras</b>
              </li>
            </ul>
          </div>
          <div className="f-packaging-delivery-section-2__steps__step-3">
            <img
              src={imgNum3}
              alt="Numero 3"
              className="f-packaging-delivery-section-2__steps__step-3__number"
            />
            <div className="f-packaging-delivery-section-2__steps__step-3__text">
              <h3 className="f-packaging-delivery-section-2__steps__step-3__text__title">
                <span>Entrega </span> el sobre
              </h3>
              <p className="f-packaging-delivery-section-2__steps__step-3__text__paragraph">
                a un funcionario de Servientrega.
              </p>
            </div>
          </div>
        </div>
        {/*  */}
        <div className="f-packaging-delivery-section-2__round-container">
          <p className="f-packaging-delivery-section-2__round-container__paragraph-1">
            Y como hasta el más pequeño acto de generosidad,{" "}
            <span className="f-packaging-delivery-section-2__round-container__paragraph-1--yellow">
              trae grandes beneficios:
            </span>
          </p>
          <div className="f-packaging-delivery-section-2__round-container__paragraph-2">
            <p>
              ¡Por cada sobre que envíes con{" "}
              <span className="number-bold">10</span> empaques Nosotras, ganarás{" "}
            </p>
            <p>
              y por cada empaque adicional te daremos{" "}
              <span className="number-bold">2</span> puntos más!*
            </p>
            <img
              className="f-packaging-delivery-section-2__round-container__paragraph-2__img"
              src={imgNumberPoints}
              alt="20 puntos"
            />
          </div>
          <p className="f-packaging-delivery-section-2__round-container__paragraph-3">
            *Los puntos serán incluidos en tu banco de puntos una vez los
            empaques sean verificados, es decir, aproximadamente{" "}
            <span className="number-bold">20</span> días después de llevarlos a
            Servientrega.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PackagingDeliverySection2
